// Transform block tree state jump to block server api
const BlockJumpTransformer = (origin) => {

    const data = { ...origin };

    data.jump_id = data.jump_id.object_id;
    
    return data
}

export default BlockJumpTransformer;